import { Card } from 'react-bootstrap'
import { FaPen } from "react-icons/fa"
import BootstrapSwitchButton from 'bootstrap-switch-button-react'

import CatTable from '../../../components/catalogos/CatTable';
import Post from '../../../api/Post';
import { PARTNER_ADD } from '../../../api/Routes';

function PartnerList({ items, editarPartner, accesToken, getToEdit}){
    const actions = (cell, row) => {

        return (
            <div className="d-flex justify-content-between align-items-center">
                <div>
                    <FaPen className='iconAction colorNaranja float-right' onClick={e=>getToEdit(row)}/>
                </div>
                <div>
                    <BootstrapSwitchButton
                        checked={row.active} 
                        onlabel="Activo"
                        onstyle="success"
                        offlabel="Inactivo"
                        offstyle="danger"
                        width={69}
                        size="sm"
                        onChange={(value)=>editarPartner({...row, "active":value})}
                    />
                </div>
            </div>
        )
    
    }

    const columns = [
        {
            text: 'ID',
            dataField: 'id',
            hidden: true,
        },  
        {
            text: 'NOMBRE',
            dataField: 'name',
            headerStyle: { width: '90%' },
            validator: (newVal, row, column) => {
                let values = {
                    'id': row.id,
                    'name': newVal,
                    'active': row.active
                }
                
                if (newVal === "") {
                    return {
                        valid: false,
                      };
                }

                if (newVal === row.name) {
                    console.log("son iguales")
                    return {
                        valid: false,
                      };
                }

                Post({url: PARTNER_ADD, data: values, header:true, access_token:accesToken})
                .then(resp=>{
                    //console.log(resp)
                })

                return true
            }
        },  
        {
            dataField: '',
            isDummyField: true,
            text: 'ACCIONES',
            headerStyle: {  width: '10%', },
            formatter: actions,
            editable:false,
        }
    ]

    return (<>
        <Card className="shadow-1 mt-3">
            <Card.Body>
                <CatTable 
                    columns={columns} 
                    items={items}
                />
            </Card.Body>
        </Card>
    </>)
}
export default PartnerList
